import React, { Suspense, useState, useEffect } from "react";
import WizardServices from "./WizardServices";
import ContactSummary from "./contactSummary";

export default function ContactAddressDetail(MainWizard: any) {

    const [save, setsave] = useState(false);
    const [unfield, setunfield] = useState(false);
    const [contactInfo, initContactInfo] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if(MainWizard.data.code){
            WizardServices.contactInfo(MainWizard.data.code).then((res) => {
                initContactInfo(res)
            })
        }

    }, []);

    const handleFieldChange = (e :any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;       
        
        console.log( Field_value)
        console.log( Field_type)
        if( Field_type === "checkbox"){
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');
        
        let updatedObject = { ...contactInfo };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        } 

        console.log(updatedObject);
        initContactInfo(updatedObject);
    };

    const saveCreator = () =>{
        console.log(contactInfo)
        WizardServices.kontactSave(contactInfo , {}) .then((res) => { setsave(true) });    
        setTimeout(function(){
            setsave(false); 
        }, 3000);    
    }

    const clearSForm = () =>{
        initContactInfo([])
    } 

    return (
        <>
            <div className="ws-12 ">
                <div className="w-65 ps">
                    <div className="box">
                        <div className="box-header">
                            <h1>Address Details</h1>
                        </div>
                        <div className="box-content allowVscroll" style={{height: "545px", marginLeft: "5%;"}}>

                            <div className="ws-12" >
                                <div className="form-format hide">
                                    <label className="control-label"> Address Type </label>

                                    <div className="label-entries">
                                        <div className="ws-12">
                                            <input type="text" id="contact.addressType" 
                                            name="addressType" placeholder="Enter Address Type"/>
                                        </div>
                                        <div className="ws-6 mt">
                                            <input type="checkbox" ng-model="contactInfo.kontactsAddresses.useMainAddress" data-ng-true-value="1" data-ng-false-value="0" />
                                            Use main address
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label" > Street (Address Line 1) </label>

                                    <div className="label-entries">
                                        <input type="text" value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.addressLine1 ? contactInfo.kontactsAddresses.addressLine1: ""}
                                         name="kontactsAddresses.addressLine1" id="contact.street" onChange={(e)=>handleFieldChange(e)} placeholder="Enter street name"/>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label" >  Town/City (Address Line 2) </label>

                                    <div className="label-entries">
                                        <input type="text" value={contactInfo && contactInfo.kontactsAddresses &&  contactInfo.kontactsAddresses.addressLine2 ? contactInfo.kontactsAddresses.addressLine2: ""} 
                                        name="kontactsAddresses.addressLine2" id="contact.city" onChange={(e)=>handleFieldChange(e)}  placeholder="Enter town/city"/>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label" >County (Address Line 3)</label>

                                    <div className="label-entries">
                                        <input type="text" id="contact.country" name="kontactsAddresses.addressLine3 " onChange={(e)=>handleFieldChange(e)}
                                            value={contactInfo && contactInfo.kontactsAddresses &&  contactInfo.kontactsAddresses.addressLine3 ? contactInfo.kontactsAddresses.addressLine3: ""} placeholder="Enter County"/>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">country (Address Line 4)</label>
                                    <div className="label-entries">
                                        <input type="text" id="cuseType" value={contactInfo && contactInfo.kontactsAddresses &&  contactInfo.kontactsAddresses.addressLine4 ? contactInfo.kontactsAddresses.addressLine4: ""} 
                                            name="kontactsAddresses.addressLine4" onChange={(e)=>handleFieldChange(e)} placeholder="Enter country"/>
                                    </div>
                                    
                                </div>

                                <div className="form-format">
                                    <label className="control-label" >  Postal Code </label>

                                    <div className="label-entries">
                                        <input type="text" value={contactInfo && contactInfo.kontactsAddresses &&  contactInfo.kontactsAddresses.addressPostCode ? contactInfo.kontactsAddresses.addressPostCode: ""} 
                                         name="kontactsAddresses.addressPostCode" id="contact.postCode"  onChange={(e)=>handleFieldChange(e)} placeholder="Enter post code"/>
                                    </div>
                                </div>
                                
                            </div> 

                        </div>

                        <div className="box-footer">
                            <div className="pull-right">
                                <button className="icon-btn edit" onClick={()=>saveCreator()}> <i className="icon-save"></i> Save </button>                       
                                <button className="btn-pink"    onClick={()=>clearSForm()}>  <i className="icon-reload"></i> Reset </button>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="w-35 ps ">
                    <ContactSummary data={contactInfo}/>
                </div>
            </div>
        </>

    )
}